export default "__VITE_ASSET__DjZuDKp3__"